export default __webpack_public_path__ + "static/media/004-A-fournisseurgas.0d125332.svg";